import {RouteHelper} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {UserService} from "../../serverService/userService/UserService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useNavigate} from "react-router-dom";
import {useDebounce} from "@uidotdev/usehooks";
import {useAuthState} from "../../context/AuthContext";
import {
    DialogSize,
    RaikoDefaultDialogPage,
    RaikoSectionContainer,
    RaikoBaseCardContainer,
    RaikoTableTitleContainer,
    RaikoCustomTable,
    RaikoBaseContainer,
    RaikoGridOneColumn,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoGridThreeColumn,
    RaikoSimpleInputOutlined,
    RaikoNumberInputOutlined,
    RaikoCustomSimpleChip,
    RaikoChipTypes,
    addNewRowToTable
} from "@moeindal/base-raiko-panel-components";
import AddNewUser from "./AddNewUser";
import Avatar from "@mui/material/Avatar";

export default function Users() {


    let page = 0
    const size = 20
    const {fundID} = useAuthState()
    const [isLoading, setIsLoading] = useState(false)
    const [usersListData, setUsersListData] = useState([])
    const [pageCount, setPageCount] = useState(0);
    const [numberOfItems, setNumberOfItems] = useState("");
    const [fullName, setFullName] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [groupName, setGroupName] = useState("")


    const fullNameFilter = useDebounce(fullName, 500);
    const groupNameFilter = useDebounce(groupName, 500);
    const nationalCodeFilter = useDebounce(nationalCode, 500)


    const service = new UserService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    useEffect(() => {
        if (typeof service !== 'undefined') {
            getUsersListFromServer()
        }
    }, [
        fullNameFilter,
        groupNameFilter,
        nationalCodeFilter,
        fundID
    ])


    function getUsersListFromServer() {
        setIsLoading(true)
        service.getUsersList(
            page,
            size,
            fundID,
            fullNameFilter,
            groupNameFilter,
            nationalCodeFilter,
        ).then(
            response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setUsersListData([])
                response.data.map((item, index) => {
                    setUsersListData(prevState => [
                        ...prevState,
                        preparationRowsUsersTable(
                            item.id,
                            (page * size) + index + 1,
                            // item.avatarUrl,
                            item.firstName && item.lastName ? `${item.firstName} ${item.lastName}` : "-",
                            item.nationalCode,
                            item.groupName,
                            item.phoneNumber,
                            item.enabled
                        )
                    ])
                })
            }
        ).catch(reason => {
            snackbar.showServerErrorMessage(reason)
        }).finally(_ => {
            setIsLoading(false)
        })
    }

    function handleChangePagination(newPage) {
        page = newPage
        getUsersListFromServer()
    }

    const navigate = useNavigate()

    function showUserInformation(id) {
        let fullName = ""
        usersListData.map((item) => {
            if (item.id === id) {
                fullName = item.fullName
            }
        })
        navigate(RouteHelper.UserInformation.globalUrl.replace(":id", id),
            {state: {fullName: fullName}, replace: false}
        )

    }

    //
    const [openDialog, setOpenDialog] = useState(false);

    function handleOpenDialog() {
        setOpenDialog(true)
    }

    function handleCloseDialog() {
        setOpenDialog(false)
    }


    function handleAddNewItemToTable(item) {
        const items = addNewRowToTable(
            preparationRowsUsersTable(
                item.id,
                1,
                item.firstName && item.lastName ? `${item.firstName} ${item.lastName}` : "-",
                item.nationalCode,
                item.groupName,
                item.phoneNumber,
                item.enabled
            ),
            usersListData
        )

        setUsersListData(items)
        handleCloseDialog()
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.Users.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                pageTitle={"افزودن عضو جدید"}
                dialogSize={DialogSize.MEDIUM}
            >
                <AddNewUser
                    handleAddNewItemToTable={handleAddNewItemToTable}
                />
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.Users.name,
                            ""
                        ),
                    ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"جستجو"}
                            subTitle={"برای جستجو عبارت مورد نظر خود را وارد نمایید."}
                        >
                            <RaikoGridThreeColumn>
                                <RaikoSimpleInputOutlined
                                    labelText={"نام و نام خانوادگی"}
                                    setValue={setFullName}
                                    value={fullName}/>
                                <RaikoSimpleInputOutlined
                                    labelText={"نام گروه"}
                                    setValue={setGroupName}
                                    value={groupName}/>
                                <RaikoNumberInputOutlined
                                    labelText={"کد ملی"}
                                    setValue={setNationalCode}
                                    value={nationalCode}/>
                            </RaikoGridThreeColumn>
                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"کاربران"}
                                amount={numberOfItems}
                                hasCreateNewItem={true}
                                handleCreateNewItem={handleOpenDialog}
                            />
                            <RaikoCustomTable
                                isLoading={isLoading}
                                data={usersListData}
                                header={usersTableHeader}
                                rowClicked={showUserInformation}
                                pageCount={pageCount}
                                handlePaginationChange={handleChangePagination}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}

export function preparationRowsUsersTable(id, number, fullName, nationalCode, groupName, phoneNumber, enabled, avatarUrl) {
    return {
        id: id,
        number: number,
        // avatar: <section className={css`width: 100%;
        //   display: flex;
        //   justify-content: center`}><Avatar src={avatarUrl} className={css`width: 38px;
        //   height: 38px;
        //   cursor: pointer;
        //   background: linear-gradient(270deg, #FAFAFA 0%, #f7f7f7 100%)`}/></section>,
        fullName: fullName ? fullName : "-",
        nationalCode: nationalCode,
        groupName: groupName,
        phoneNumber: phoneNumber ? phoneNumber : "-",
        enabled: enabled ?
            <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/>
            : <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
    }
}

export const usersTableHeader = [
    {
        id: "number",
        label: "#"
    },
   /* {
        id: "avatar",
        label: "نمایه",
    },*/
    {
        id: "fullName",
        label: "نام و نام خانوادگی"
    },
    {
        id: "nationalCode",
        label: "کد ملی",
    },
    {
        id: "groupName",
        label: "نام گروه",
    },
    {
        id: "phoneNumber",
        label: "شماره همراه"
    },
    {
        id: "enabled",
        label: "وضعیت"
    },
]